export function getTranslation<TObject, TTranslation extends { languageCode: string }, TValue>(
	object: TObject,
	languageCode: string,
	translationsSelector: (object: TObject) => TTranslation[],
	valueSelector: (translation: TTranslation) => TValue
): TValue | "" {
	const translations = translationsSelector(object);
	const preferredLanguage = languageCode || "fi";
	const translation =
		translations.find((item) => item.languageCode === preferredLanguage) ?? translations[0];

	return translation ? valueSelector(translation) : "";
}
